import { Component } from '@angular/core';
//import {ToasterModule, ToasterService} from 'angular2-toaster';
import { UserInfos } from './_models/user.infos';
import { AuthenticationService } from './_services/local/authentication.service';
import { ToasterConfig } from 'angular2-toaster';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Etiqueta Fácil';
  currentUser: UserInfos;
  public toasterconfig: ToasterConfig = new ToasterConfig({ tapToDismiss: true, timeout: 4500 });
  
  constructor(
      private authenticationService: AuthenticationService
  ) {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }
}
